import React from 'react';
import React3 from 'react-three-renderer';
import * as THREE from 'three';
const locations = require('./rack_double_bike_locations.json');

export default class Bikes extends React.Component {
  state = {
    points: locations.points.map((d) => {
      const pt = new THREE.Vector3(-d.x, d.y, d.z);
      return pt;
    }),
    rotations: locations.points.map((d) => {
      const rotation = new THREE.Euler(0, d.z > 0 ? Math.PI : 0, 0);
      return rotation;
    })
  };
  render() {
    const {
      geometry: { vertices, faceVertexUvs, faces },
      positions
    } = this.props;
    const geo = { vertices, faceVertexUvs, faces };
    const { points, rotations } = this.state;
    return (
      <object3D frustumCulled>
        {positions.map((position, j) => {
          return (
            <object3D frustumCulled key={j} position={position}>
              {points.map((point, i) => {
                return (
                  <object3D
                    frustumCulled
                    position={point}
                    rotation={rotations[i]}
                    key={i}
                  >
                    {/* <mesh castShadow receiveShadow>
                      <geometry {...geo} />
                      <meshStandardMaterial
                        color={0xff0ffff}
                        side={THREE.DoubleSide}
                        metalness={1}
                        roughness={0.2}
                      />
                    </mesh> */}
                  </object3D>
                );
              })}
            </object3D>
          );
        })}
      </object3D>
    );
  }
}

Bikes.defaultProps = {
  geometry: new THREE.Geometry()
};



// WEBPACK FOOTER //
// ./src/components/Results/ResultsScene/Bikes/index.js